import Image from 'next/image'

import { Container, Caption, HighlightText, SectionHeader } from '@/components'
import { AnchorButton } from '@/components/AnchorButton'

import Woman from '/public/images/interconnect-box.webp'

import { ADVANTAGES } from './constants'

import styles from './Interconnect.module.scss'

export const Interconnect = () => {
  return (
    <section className={styles.interconnect}>
      <Container>
        <SectionHeader
          tagText="Lançamento"
          tagBackground="gray"
          title={
            <>
              <b>InterConnect Box</b>: Solução rápida e segura para análise de
              crédito de pequenas e médias empresas.
            </>
          }
        />

        <div className={styles.interconnect__wrapper}>
          <div className={styles.interconnect__advantages}>
            {ADVANTAGES.map(({ icon, title, text }, index) => (
              <HighlightText
                icon={icon}
                title={title}
                text={text}
                key={`interconnect-advantage-${index}`}
                customClass={styles.interconnect__advantage}
              />
            ))}
          </div>

          <div className={styles.interconnect__details}>
            <AnchorButton section="interconnectBox" customClass={styles.cta} />

            <Caption
              icon="equifax-info"
              text="Serviço disponível apenas no plano Pós-pago"
            />

            <Image
              src={Woman}
              loading="lazy"
              alt="homem utilizando o InterConnect Box em seu notebook"
              style={{
                width: '100%',
                height: 'auto'
              }}
            />
          </div>
        </div>
      </Container>
    </section>
  )
}
